export enum ErrorCode {
  DefaultError = 'E000',
  NotAllowed = 'E001',
  SchemaValidationError = 'E002',
  MissingAuthorizationHeader = 'E003',
  FaultyAuthorizationHeader = 'E004',
  InvalidUuid = 'E005',
  InvalidParameter = 'E006',

  PaymentIncorrectStripeConfiguration = 'P001',
  PaymentSignatureVerificationFailed = 'P002',
  PaymentOrderDoesntExist = 'P003',
  PaymentAwaitingOrderConfirmationFromStripe = 'P004',
  PaymentInvalidSecret = 'P005',
  PaymentUnableToCreateOrderForPaymentIntent = 'P006',
  PaymentAlreadyUsed = 'P007',
  PaymentExpired = 'P008',
  PaymentTokenVerificationFailed = 'P009',
  PaymentOrderStateTransitionFailed = 'P010',
  PaymentResponseValidationFailed = 'P011',

  KeycloakResponseParseError = 'K001',
  KeycloakSessionRetrievalFailed = 'K002',
  KeycloakSessionDeletionFailed = 'K003',
  KeycloakUserAlreadyExists = 'K004',
  KeycloakUserDeletionFailed = 'K005',

  DeviceNotFound = 'D001',
  DeviceCertificateMissing = 'D002',
  DeviceTokenMissing = 'D003',
  DeviceTokenVerificationFailed = 'D004',

  UserNotFound = 'U001',
  UserIsNotAuthorizedAndNeedsToLogin = 'U002',
  UserUsingWrongToken = 'U003',
  UserTokenNotProvided = 'U004',
  UserProfilePictureNotFound = 'U005',

  MeasurementNotFound = 'M001',
  MeasurementCalculatorExecutionError = 'M002',
  MeasurementCompleteButReportInProgress = 'M003',

  FormulaSetNotFound = 'F001',
  FormulaSetNoReleasedVersion = 'F002',
  FormulaSetOnlyDraftUpdateAllowed = 'F003',
}
